'use strict'

const vfitzPlus = {
  HOST_API: null,
  DOMAIN: null,
  authid: null,
  fn: {},
  routes: {
    collections_url: "/collections",
    predictive_search_url: "/search/suggest",
    search_url: "/search"
  },
  data: {
    menuDropdownSelectPrefix: 'Select',
    menuDorpdownStructure: [{ level: 0, label: 'Level1' }, { level: 2, label: 'Level2' }, { level: 1, label: 'Level3' }, { level: 3, label: 'Level4' }, { level: 4, label: 'Level5' }],
    menuTopbarStructure: [{ level: 0, label: 'Level1' }, { level: 2, label: 'Level2' }, { level: 1, label: 'Level3' }, { level: 3, label: 'Level4' }, { level: 4, label: 'Level5' }],
    menuTopbarTitle: 'Collections',
    separatorLevels: '^%',
    separatorArray: '^|',
    levels: []
  }
}

vfitzPlus.fn.setCookie = (objName, objValue, objHours) => {
  var str = objName + "=" + decodeURI(objValue) + ";path=/"; //编码
  if (objHours > 0) {//为0时不设定过期时间，浏览器关闭时cookie自动消失
    var date = new Date();
    var ms = objHours * 3600 * 1000;
    date.setTime(date.getTime() + ms);
    str += "; expires=" + date.toGMTString();
  }
  document.cookie = str;
}

vfitzPlus.fn.getCookie = (objName) => {//获取指定名称的cookie的值
  var arrStr = document.cookie.split("; ");
  for (var i = 0; i < arrStr.length; i++) {
    var temp = arrStr[i].split("=");
    if (temp[0] == objName) return encodeURI(temp[1]);  //解码
  }
  return "";
}

// load script file
vfitzPlus.fn.loadScript = async (url) => {
  const data = await new Promise(function (resolve, reject) {
    var script = document.createElement("script");
    script.onload = resolve;
    script.onerror = reject;
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  });
  return data;
};

// load jQuery file
vfitzPlus.fn.loadjQuery = async () => {
  if ((typeof jQuery === "undefined") || (jQuery.fn.jquery.replace(/\.(\d)/g, ".0$1").replace(/\.0(\d{2})/g, ".$1") < "1.08.01")) {
    return await vfitzPlus.fn.loadScript("https://cdn.shopifycdn.net/s/files/1/0620/2707/1720/files/jquery-1.12.4.min.js?v=1660611913")
  } else {
    return await Promise.resolve();
  }
};

vfitzPlus.fn.loadStyle = async (url) => {
  const data = await new Promise((resolve, reject) => {
    var style = document.createElement('link');
    style.onload = resolve;
    style.onerror = reject;
    style.href = url;
    style.rel = 'stylesheet';
    style.type = 'text/css';
    document.getElementsByTagName("head").item(0).appendChild(style);
  });
  return data;
}

// 获取指定 level的菜单数据, 支持level关键字的过滤
vfitzPlus.fn.getLevelArrayByIndex = (index = 0, keyWord = []) => {
  // console.log('getLevelArrayByIndex', index, keyWord)
  const levels = {}
  // vfitzPlus.data.levels.filter(item => keyWord.every(w => new RegExp(`.*${w}\\^%`).test(item))).map(item => {
  vfitzPlus.data.levels.filter(item => item.indexOf(keyWord.join('^%')+'^%')>-1).map(item => {
// vfitzPlus.data.levels.filter(item => /`.*${keyWord.join('^%')}\\^%`/.test(item) ).map(item => {    
    const _arr = item.split(vfitzPlus.data.separatorLevels);
    // console.log('###', item, keyWord.join('^%'), _arr, new RegExp(`.*${keyWord.join('^%')}\\^%`).test(item)) 
    const _handle = _arr.pop()
    const _nextlevel = _arr[index + 1]
    let _key = _arr[index]
    if (!levels[_key] && _key.length > 0) levels[_key] = { handles: [], next: [] }
    let _keyWord = [].concat(keyWord)
    _keyWord.push(_key)
    if (levels[_key]) {
      // console.log('_handle',_key, _handle, _keyWord)
      // console.log('###', item, _keyWord.join('^%'), _arr, item.indexOf(_keyWord.join('^%')))
      if(item.indexOf(_keyWord.join('^%')) > -1){
        levels[_key].handles.push(_handle);
      }
      if (_nextlevel && _nextlevel.length > 0) levels[_key].next.push(_nextlevel);
    }
  })

  const returnData = []
  // console.log(index, Object.keys(levels) )
  let _key_Levels = Object.keys(levels).sort()
  if(3 == index){ _key_Levels = _key_Levels.reverse() }
  _key_Levels.map((k, idx) => {
    returnData.push({
      id: idx,
      text: k,
      value: k,
      handles: levels[k].handles.sort().slice(0,2),
      next: levels[k].next.length,
      keyword: keyWord
    })
  })
  // console.log('getLevelArrayByIndex', index, keyWord,returnData, levels)
  return returnData
}

vfitzPlus.fn.setSelectOptions = (selector_vidx = 99, level = 0, keyword = []) => { 
  console.log('setSelectOptions', selector_vidx, level, JSON.stringify(keyword))
  if (selector_vidx >= vfitzPlus.data.menuDorpdownStructure.length) return;
  let data = vfitzPlus.fn.getLevelArrayByIndex(level, keyword);

  if(1 == selector_vidx && 1 == level && '["Wheels"]' == JSON.stringify(keyword)){
    //分组
    let __options = []
    let _optgp = {}
    data.map(item => {
      let _d = `<option value='${JSON.stringify(item)}' class="icon-make icon-l-${item.text.toLowerCase().replace(/ /g, '-')}">${item.text}</option>`
      if( ! _optgp[item.text.slice(0,1).toUpperCase()]) _optgp[item.text.slice(0,1).toUpperCase()] = []
      _optgp[item.text.slice(0,1).toUpperCase()].push(_d)
      __options.push(_d)
    });
    console.log('分组', _optgp)

    let optgp = Object.keys(_optgp).map(key => `<optgroup label="${key}">${_optgp[key].join('')}</optgroup>`)
    console.log('optgp', optgp)
    
    $(`[vid="vfitzPlus-menu-dropdown"] select[vidx="${selector_vidx}"]`).empty().html(optgp).val(null).trigger('change');    
  }else{
    // 不分组
    let _options = data.map(item => new Option(item.text, JSON.stringify(item), false, false));
    $(`[vid="vfitzPlus-menu-dropdown"] select[vidx="${selector_vidx}"]`).empty().append(_options).val(null).trigger('change');
  }

}

vfitzPlus.fn.emptySelectOptions = (selector_vidx = 99) => {
  for (let i = selector_vidx + 1; i < vfitzPlus.data.menuDorpdownStructure.length; i++) {
    $(`[vid="vfitzPlus-menu-dropdown"] select[vidx="${i}"]`).empty().val(null).trigger('change');
  }
}

// 下拉菜单 初始化
vfitzPlus.fn.menuTopbarInit = () => {
  function createlist(idx, word, selector) {
    if (idx >= vfitzPlus.data.menuTopbarStructure.length) return;
    let { level, label } = vfitzPlus.data.menuTopbarStructure[idx];
    let data = vfitzPlus.fn.getLevelArrayByIndex(level, word);
    data.forEach(v => {
      let _html = ''
      if (v.next == 0) {
        _html = `<li class="list-child"><a href="${v.handles[0]}">${v.value}</a></li>`
      } else {
        _html = `<li vid="li-${idx}"><a href="${v.handles[0]}" class="more">${v.value}</a><ul vid="ul-${idx}|${v.value}" class="node-${idx}" ></ul></li>`
      }
      $(selector).append(_html)
      createlist(idx + 1, [v.value], `[vid="vfitzplus-menu-topbar"] [vid="ul-${idx}|${v.value}"]`)
    })
  }
  // console.time("递归遍历")

  $('[vid="vfitzplus-menu-topbar"]').append(`<style>
  [vid="vfitzplus-menu-topbar"] {width: max-content;}
  [vid="vfitzplus-menu-topbar"] ul{padding: 0; list-style: none;} 
  [vid="vfitzplus-menu-topbar"] li { padding:0; list-style:none; position: relative;padding: 0.5rem 1rem;} /*这一级是导航*/
  [vid="vfitzplus-menu-topbar"] li a { 
    cursor: pointer;
    display: inline-block;
    border: none;
    box-shadow: none;
    text-decoration: underline;
    text-underline-offset: 0.3rem;
    color: rgb(var(--color-link));
      background-color: transparent;
      font-size: 1.4rem;
      font-family: inherit;  
      text-decoration: none;
      }
  [vid="vfitzplus-menu-topbar"] li[vid]:hover {  background: var(--gradient-base-background-2) }
  [vid="vfitzplus-menu-topbar"] li a:hover {   text-decoration-line: underline; }
  [vid="vfitzplus-menu-topbar"] li ul { 
    position:absolute; float:left; display:block; z-index:9999;
    min-width: 15rem;
    border: 1px solid var(--gradient-base-background-2);
    display: none;
    background-color: var(--gradient-base-background-1);  
    box-shadow: 1px 1px 2px -1px grey;
  } /*这是第二级菜单*/
  [vid="vfitzplus-menu-topbar"] li ul a { text-decoration:none; color:#333333; width: max-content;}
  [vid="vfitzplus-menu-topbar"] li ul ul{ top:-1px;left:100%;} /*从第三级菜单开始,所有的子级菜单都相对偏移*/
</style>`);

  $('[vid="vfitzplus-menu-topbar"]').parent().css({ "position": "relative" });
  $('[vid="vfitzplus-menu-topbar"]').append(`<ul ><li><a href='#'>${vfitzPlus.data.menuTopbarTitle}</a><ul vid="ul-root" class="node-root"></ul></li></ul>`);
  createlist(0, [], `[vid="vfitzplus-menu-topbar"] [vid="ul-root"]`);
  // console.timeEnd("递归遍历")

  $('[vid="vfitzplus-menu-topbar"] a').click(e => {
    let _cookie_data = [$(e.currentTarget).text()]
    $(e.currentTarget).parents('ul[vid]').each((idx, dom) => {
      let _v = $(dom).attr('vid').split('|')[1]
      if (_v) _cookie_data.push(_v)
    })
    vfitzPlus.fn.setCookie('vfitzplus_customer_levelSelected', JSON.stringify(_cookie_data.reverse()))
  })

  $('[vid="vfitzplus-menu-topbar"]' + ' li').hover(
    function () {
      $(this).children("ul").show(); //mouseover
    }, function () {
      $(this).children("ul").hide(); //mouseout
    });

}

// 初始化函数
vfitzPlus.fn.menuDropdownInit = () => {
  console.log('初始化成功');

  $('[vid="vfitzPlus-menu-dropdown"][role!="vfitzplus-block"]').append(`
    <style>
      [vid="vfitzPlus-menu-dropdown"]{display: flex; justify-content: center; margin: 2rem 0; height: fit-content;}
      [vid="vfitzPlus-menu-dropdown"] select{ flex:1; max-width: 15%; margin: 0 0.5rem; }
      /* [vid="vfitzPlus-menu-dropdown"] .select2-container{margin: 0 0.5rem;} */
      [vid="vfitzPlus-menu-dropdown"] #vfitzPlus-select2-dropdown-parent .select2-results .select2-results__options{max-height: 45vh;}
      [vid="vfitzPlus-menu-dropdown"] button{margin: 0 0.5rem; width: 5%;}
    </style>
    <div id="vfitzPlus-select2-dropdown-parent"></div>
`);

  vfitzPlus.data.menuDorpdownStructure.forEach((item, index) => {
    $('[vid="vfitzPlus-menu-dropdown"]').append(`<select level=${item.level} vidx=${index}><options/></select>`)
  })

  vfitzPlus.data.menuDorpdownStructure.forEach((item, index) => {
    // $('[vid="vfitzPlus-menu-dropdown"]').append(`<select level=${item.level} vidx=${index}><options/></select>`)

    // 格式化logo
    function formatState (state) {
      if (!$(state.element).hasClass('icon-make')) {
        return state.text;
      }
      var $state = $(
        '<span class="make-format"><l class="make-block '+ $(state.element).attr('class') +'"></l>' + state.text + '</span>'
      );
      return $state;
    };
    
    $(`[vid="vfitzPlus-menu-dropdown"] select[level="${item.level}"]`).select2({
      width: 'resolve',
      //         data: [],
      templateResult: formatState,
      minimumResultsForSearch: 1,//Infinity, // Infinity ,
      placeholder: `${vfitzPlus.data.menuDropdownSelectPrefix} ${item.label}`,
      selectionCssClass: 'vfitzPlus_select2_selection',
      dropdownParent: $('#vfitzPlus-select2-dropdown-parent'),
      theme: 'bootstrap4',
      //         allowClear: true
    })
  });

  
  // 	$('[vid="vfitzPlus-menu-dropdown"]').append('<div id="vfitzPlus-select2-dropdown-parent"></div>')
  $('[vid="vfitzPlus-menu-dropdown"]').append('<button>Go</button>')
  $('[vid="vfitzPlus-menu-dropdown"] button').click(e => {
    if (vfitzPlus.data.levelSelected) {
      // console.log(vfitzPlus.data.levelSelected)
      // console.log(vfitzPlus.data.levelSelected.keyword.concat([vfitzPlus.data.levelSelected.value]))
      let _cookie_data = vfitzPlus.data.levelSelected.keyword.concat([vfitzPlus.data.levelSelected.value])
      vfitzPlus.fn.setCookie('vfitzplus_customer_levelSelected', JSON.stringify(_cookie_data))
      window.open(vfitzPlus.data.levelSelected.handles[0]);
    }
  })

  // select2 选中事件，选中时清空后几级的options, 重新加载下一个select`s DOM 的options数据
  $('[vid="vfitzPlus-menu-dropdown"] select[level]').on("select2:select", function (event) {
    try {
      console.log(event.params, event)
      let data = JSON.parse(event.params.data.id);
      vfitzPlus.data.levelSelected = data;
      let _keyword = [].concat(data.keyword, data.value);
      let _selector_vidx = 1 + 1 * $(this).attr('vidx'); // 下一个加载数据的select2 dom的 vidx
      if (_selector_vidx < vfitzPlus.data.menuDorpdownStructure.length) {
        let _level = vfitzPlus.data.menuDorpdownStructure[_selector_vidx]['level']; // 下一个 数据获取的级别
        vfitzPlus.fn.setSelectOptions(_selector_vidx, _level, _keyword);
        vfitzPlus.fn.emptySelectOptions(_selector_vidx);
      }
    } catch (error) {
      
    }
    
  });

  vfitzPlus.fn.setSelectOptions(0, vfitzPlus.data.menuDorpdownStructure[0]['level'], []);  // 初始化第一个 select2 dom  
  // $('[vid="vfitzPlus-menu-dropdown"]').show();
}

// 初始化函数
vfitzPlus.fn.vinDecodeInit = () => {
  const style = `
  [vid="vfitzplus-vin-input"]{
    padding: 0 1rem; appearance: none; letter-spacing: 2px;
    background-color: transparent;
    border: 0.1rem solid transparent;
    border-radius: 0;
    color: rgb(18,18,18);
    font-size: 1.4rem;
    width: 100%;
    box-shadow: 0 0 0 0.1rem rgb(18 18 18 / 55%);
    height: 4rem;
    box-sizing: border-box;
    transition: box-shadow var(--duration-short) ease;
    outline: none;
  }
  .vin-input .vin-input-label{position: absolute; top: -0.5rem; font-size: 0.1rem; left: 1rem; color: rgba(18,18,18,0.3);}
  [vid="vfitzplus-vin-input"]:focus{box-shadow: 0 0 0 0.2rem rgba(18,18,18,.75); outline: transparent;}
  [vid="vfitzplus-vin"] .vin-input{position: relative;}
  [vid="vfitzplus-vin-input-icon"]{width: 2rem; height: 2rem; cursor: pointer; margin: 0 1rem; position: absolute; right: 0; top: 1rem;}
  [vid="vin-decode-results"] div{margin-right: 1rem; line-height: normal;}
  [vid="vin-decode-results"] .label{margin-right: 1rem; font-size: 0.5rem; color: rgba(18,18,18,0.3);}
  [vid="vin-loading"]{margin-top: 1px; padding: 0.3rem 1rem; padding: 1rem;position:absolute; width:100%;  z-index: 99;box-shadow: 0 0 0 0.1rem rgb(18 18 18 / 55%); background: white; display:none; }
  [vid="vin-loading"] svg{width: 2rem; margin-right: 1rem;}
  [vid="vin-results"]{margin-top: 1px; padding: 1rem;position: absolute; width:100%; z-index: 99;box-shadow: 0 0 0 0.1rem rgb(18 18 18 / 55%); background: white; display: none;} 
  [vid="vin-decode-results"]{display: flex;}
  [vid="vin-suggest-results"]{border-top: 1px solid rgba(18,18,18,0.1); margin-top: 1rem;}
  [vid="vin-shop-search"]{display: flex; justify-content: space-between;align-items: center;}
  [vid="vfitzplus-vin-input-arrow"]{width: 2rem;height: 2rem;}
  [vid="vin-shop-search"]{cursor: pointer; border: none; box-shadow: none; text-decoration: none; color: rgb(18,18,18); background-color: transparent;border-top: 1px solid rgba(18,18,18,0.1);}
  [vid="vin-shop-search"]:hover{background:rgba(18,18,18,0.1);}
  `;

  $('[vid="vfitzplus-vin"][role!="vfitzplus-block"]').css({ position: 'relative' });
  $('[vid="vfitzplus-vin"][role!="vfitzplus-block"]').append(`
  <svg xmlns="http://www.w3.org/2000/svg" class="hidden">
    <symbol id="vfitzplus-icon-search" viewBox="0 0 18 19" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 112.85 3.5a5.784 5.784 0 018.18 8.18zm.26 1.12a6.78 6.78 0 11.72-.7l5.4 5.4a.5.5 0 11-.71.7l-5.41-5.4z" fill="currentColor"></path>
    </symbol>

    <symbol id="vfitzplus-icon-close" fill="none" viewBox="0 0 18 17">
      <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
    </symbol>
    
    <symbol id="vfitzplus-icon-arrow" fill="none" viewBox="0 0 14 10">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
    </symbol>
  </svg>  
  `);
  
  $('[vid="vfitzplus-vin"][role!="vfitzplus-block"]').append(`
    <style>${style}</style>
    <div class="vin-input">
      <input vid="vfitzplus-vin-input" type="text" value="" placeholder="Input VIN Code."></input>
      <svg vid="vfitzplus-vin-input-icon" class="search" aria-hidden="true" focusable="false" role="presentation">
        <use href="#vfitzplus-icon-search"></use>
      </svg>
      <svg vid="vfitzplus-vin-input-icon" class="clean" aria-hidden="true" focusable="false" role="presentation" style="display:none;">
        <use href="#vfitzplus-icon-close"></use>
      </svg>        
      
    </div>

    <div vid="vin-loading">
      <div style="display:flex;align-items: center;">
        <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
        <span>Searching ...</span>
      </div>
    </div>
    <div vid="vin-results">
      <div vid="vin-decode-results"/>
      <div vid="vin-suggest-results"/>
      <a vid="vin-shop-search"/>
    </div>`);
  let inputtime; // 定义变量接收定时器
  function getVIN(scope, vin) {
    if (vin.length < 3 && $(scope).find('[vid="vin-loading"]').is(":visible")) { return false; }
    clearTimeout(inputtime)
    inputtime = setTimeout(() => {
      startsearch(scope);
      $.getJSON(`https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvalues/${vin}?format=json`, function (json) {
        // console.log(json)
        if (json && json.Results && json.Results.length) {
          let { Make, Model, ModelYear, Series } = json.Results[0]
          let _searchdata = [Make, Model, ModelYear];
          let query = `"${_searchdata.filter(v => v).join('" "')}"`;
          // console.log(_searchdata.concat(Series).join('\t'))
          if (_searchdata.join('').length > 0) {
            vfitzPlus.fn.setCookie('vfitzplus_customer_vindecode', JSON.stringify({ vin: vin, make: Make, model: Model, year: ModelYear, series: Series }));
            $(scope).find('[vid="vin-shop-search"]').append(`
              <div>Search for "${ _searchdata.join(' ') }"</div>
              <svg vid="vfitzplus-vin-input-arrow" aria-hidden="true" focusable="false" role="presentation">
                <use href="#vfitzplus-icon-arrow"></use>
              </svg>
            `);
            $(scope).find('[vid="vin-shop-search"]').attr('href', `${vfitzPlus.routes.search_url}?q=${query}&type=product,page&options[unavailable_products]=hide&options[prefix]=last`)      
          }
          $(scope).find('[vid="vin-decode-results"]').empty();
          $(scope).find('[vid="vin-decode-results"]').append(`
              <div><div class="label">Make</div>${Make}</div>
              <div><div class="label">Model</div>${Model}</div>
              <div><div class="label">Year</div>${ModelYear}</div>
          `);
          
          suggest(scope, query);
        }
      });
    }, 500)
  };

  function suggest(scope, query) {
    $(scope).find('[vid="vin-suggest-results"]').empty()
    console.log('suggest:', query)
    $.get(`${vfitzPlus.routes.predictive_search_url}?q=${query}&resources[type]=product,collection&section_id=vfitzplus-predictive_search`, function (data = '') {
      if (data.indexOf('vid="predictive-results"') > -1) {
        $(scope).find('[vid="vin-suggest-results"]').append(data);
      } else {
        $(scope).find('[vid="vin-suggest-results"]').append(`<div style=""> Not find Product(s). </div>`)
      }
      $(scope).find('[vid="vin-results"]').show();
      $(scope).find('[vid="vin-loading"]').hide();
    });

  }

  function startsearch(scope) {
    $(scope).find('[vid="vin-loading"]').show();
    $(scope).find('[vid="vin-results"]').hide();
    $(scope).find('[vid="vin-decode-results"]').empty();
    $(scope).find('[vid="vin-suggest-results"]').empty();
    $(scope).find('[vid="vin-shop-search"]').empty();
    $(scope).find('[vid="vin-shop-search"]').attr('href','#');
  }

  function clean(scope) {
    $(scope).find('[vid="vin-results"]').hide();
    $(scope).find('[vid="vin-loading"]').hide();
    $(scope).find('[vid="vin-decode-results"]').empty();
    $(scope).find('[vid="vin-suggest-results"]').empty();
    $(scope).find('[vid="vin-shop-search"]').empty();
    $(scope).find('[vid="vin-shop-search"]').attr('href','#');
    $(scope).find('[vid="vfitzplus-vin-input"]').val('');
    $(scope).find('[vid="vfitzplus-vin-input-icon"].search').show();
    $(scope).find('[vid="vfitzplus-vin-input-icon"].clean').hide();
    
  }

  $('[vid="vfitzplus-vin-input"]').off("input").on("input", function () {
    let scope = $(this).parents('[vid="vfitzplus-vin"]')[0];
    let val = $(this).val().replace(/ /g, '');
    if(val.length > 0){
      $(scope).find('[vid="vfitzplus-vin-input-icon"].search').hide();
      $(scope).find('[vid="vfitzplus-vin-input-icon"].clean').show();      
    }
    if(val.length >= 3) {getVIN(scope, val) };
  });

  $('[vid="vfitzplus-vin-input-icon"].clean').off('click').on("click", function () {
    let scope = $(this).parents('[vid="vfitzplus-vin"]')
    clean(scope);
  })

  $('body').on("click", function (e) {
    if ($(e.target).closest('[vid="vfitzplus-vin"]').length == 0) {
      let scope = $(this).parents('[vid="vfitzplus-vin"]')
      clean(this);
    }
  });
}

/* 主加载函数 */
(function (global, factory) {
  if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = global.document ?
      factory(global, true) :
      function (w) {
        if (!w.document) {
          throw new Error("jQuery requires a window with a document");
        }
        return factory(w);
      };
  } else {
    factory(global);
  }
  // Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function (window, noGlobal) {
  if (!window.vfitzPlus) window.vfitzPlus = vfitzPlus;
  window.vfitzPlus.data.separatorLevels = window.vfitzPlus_liquid_separatorLevels || vfitzPlus.data.separatorLevels;
  window.vfitzPlus.data.separatorArray = window.vfitzPlus_liquid_separatorArray || vfitzPlus.data.separatorArray;
  let _vfitzPlus_liquid_levels = window.vfitzPlus_liquid_levels ? window.vfitzPlus_liquid_levels.split(vfitzPlus.data.separatorArray) : [];
  // _vfitzPlus_liquid_levels.pop(); // 已禁用， 已忘记之前为什么要增加pop动作 <2022-07-08>
  window.vfitzPlus.data.levels = _vfitzPlus_liquid_levels;
  window.vfitzPlus.routes = window.vfitzPlus_routes || window.vfitzPlus.routes;

  // vfitzPlus_liquid_levels = vfitzPlus_liquid_separatorLevels = vfitzPlus_liquid_separatorArray = null;

  (async function () {
    await vfitzPlus.fn.loadjQuery();
    await vfitzPlus.fn.loadScript("https://cdn.shopifycdn.net/s/files/1/0620/2707/1720/files/select2.min.js?v=1660611696");
    await vfitzPlus.fn.loadStyle("https://cdn.shopifycdn.net/s/files/1/0620/2707/1720/files/select2.min.css?v=1660611696");
    await vfitzPlus.fn.loadStyle("https://cdn.shopifycdn.net/s/files/1/0620/2707/1720/files/select2-bootstrap4.min.css?v=1660611696");
    vfitzPlus.fn.menuDropdownInit();
    vfitzPlus.fn.menuTopbarInit();
    vfitzPlus.fn.vinDecodeInit();
  }());

}));
if(vfitzPlus){
  vfitzPlus.fn.menuTopbarInit=()=>{};
};
if(vfitzPlus){ 
  vfitzPlus.HOST_API='https://vfitzplus.tirewheelconnect.com/whapi/onlinestore'; 
  vfitzPlus.DOMAIN='oemrimshop.myshopify.com';
  vfitzPlus.authid='e4d26c3752de24138b66fb20e358103b'; 
  vfitzPlus.data.menuTopbarStructure =[{"level":0,"label":"Level1"},{"level":1,"label":"Level2"},{"level":2,"label":"Level3"}]
  vfitzPlus.data.menuDorpdownStructure =[{"level":0,"label":"Wheels | By Size"},{"level":1,"label":"-"},{"level":2,"label":"-"},{"level":3,"label":"-"}]
  vfitzPlus.data.menuDropdownSelectPrefix =""
  vfitzPlus.data.menuTopbarTitle ="Collections"
}
if(vfitzPlus && vfitz_dropmenu_tab_init){
  vfitz_dropmenu_tab_init()
}